import { useLanguage } from '../../contexts/LanguageContext';
import { translations } from '../../translations';
import type { PartnersStrings } from '../../locales/partners';

export function usePartnersStrings(): PartnersStrings {
  const { currentLanguage } = useLanguage();
  const pack = translations[currentLanguage as 'en' | 'es'].partners as PartnersStrings | undefined;
  if (!pack) {
    return translations.en.partners as PartnersStrings;
  }
  return pack;
}
